import "./StartYourJourney.module.css";
import MainNavigation from "@/reusable_sections/Header";
import LetSBuildYourPlan from "./sections/LetSBuildYourPlan";
import LocationHours from "./sections/LocationHours";
import StayMotivated from "./sections/StayMotivated";
import FooterEssentials from "@/reusable_sections/Footer";
export default function StartYourJourneyPage() {
  return <div>
      <MainNavigation />
      <LetSBuildYourPlan />
      <LocationHours />
      <StayMotivated />
      <FooterEssentials />
    </div>;
}